module.exports = __webpack_public_path__ + "static/media/open.729b52bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/open.png
// module id = 676
// module chunks = 0 1